module.exports = __webpack_public_path__ + "@/assets/img/030-girl-17.5f15670d.svg";